import { Colors } from 'components/map/Styles';
import { buildingCircle, churchCircle, crownCircle, defaultIcon } from 'components/map/icons';

import {
  Aktivitet,
  Authority,
  BebyggelseobjektPublicerad,
  BebyggelseobjektUtkast,
  BebyggelseobjektVersionHistorisk,
  Handelse
} from 'models';

import { AuthorityRolesEnum, SkyddstypEnum } from 'enums';

import { isBebyggelseobjektPublicerad } from './typeGuards';

export const getHandelseDateringDisplayNameForPresentation = (handelse: Handelse | undefined): string => {
  if (!handelse || !handelse.datering_kand) return 'Okänt årtal';

  if (
    (handelse.datering_from && !handelse.datering_tom) ||
    (handelse.datering_from && handelse.datering_from === handelse.datering_tom)
  ) {
    return `${handelse.datering_from}`;
  } else if (handelse.datering_from && handelse.datering_tom) {
    return `ca ${handelse.datering_from}–${handelse.datering_tom}`;
  }

  return '';
};

export const getIconBySkydd = (skyddstyp: SkyddstypEnum, havtSkydd: boolean): string => {
  switch (skyddstyp) {
    case SkyddstypEnum.ANMALNINGSPLIKT:
      return havtSkydd ? buildingCircle(Colors.RAA_GRAY_5) : buildingCircle(Colors.RAA_BLUE);
    case SkyddstypEnum.IDENTIFIERAT_KULTURVARDE:
      return buildingCircle(Colors.RAA_BLUE);
    case SkyddstypEnum.KYRKLIGT_KULTURMINNE:
      return churchCircle();
    case SkyddstypEnum.STATLIGT_BYGGNADSMINNE:
      return havtSkydd ? crownCircle(Colors.RAA_GRAY_5) : crownCircle();
    case SkyddstypEnum.BYGGNADSMINNE:
      return buildingCircle(Colors.RAA_ORANGE);
    case SkyddstypEnum.FORSTORT_KULTURVARDE:
      return buildingCircle(Colors.RAA_GRAY_5);
    default:
      return defaultIcon();
  }
};

export const isAnsvarigOrganisationOrGranskare = (
  aktivitet: Aktivitet,
  authority: Authority | undefined,
  authorityRoles: AuthorityRolesEnum[]
) => isAnsvarigOrganisation(aktivitet, authority) || authorityRoles.includes(AuthorityRolesEnum.GRANSKARE);

export const isAnsvarigOrganisation = (aktivitet: Aktivitet, selectedOrganisation: Authority | undefined): boolean =>
  aktivitet.ansvarig_organisation.organisationsnummer === selectedOrganisation?.organisation_nummer;

export const isSkyddHavt = (
  bebyggelseobjekt: BebyggelseobjektUtkast | BebyggelseobjektPublicerad | BebyggelseobjektVersionHistorisk
) =>
  (isBebyggelseobjektPublicerad(bebyggelseobjekt) || isBebyggelseobjektPublicerad(bebyggelseobjekt)) &&
  bebyggelseobjekt.sammansatt?.havt_skydd === true;
